export default __webpack_public_path__ + "static/Plots0020-34e70748d6c21bf56845b9623393ae97.jpg";